// Nav entry of Dictionary (shell/nav.ts collects every routes/*.nav.ts; `order` places it in the rail, the tabs and Lisää).
import { defineNav } from '../shell/nav-entry';

export const nav = defineNav({
  id: 'dictionary',
  path: '/dictionary',
  icon: 'dictionary',
  group: 'find',
  phone: 'tab',
  order: 800,
  load: () => import('./Dictionary'),
});
